import { useQuery } from '@tanstack/react-query'
import { fetchUsageStats } from '@/lib/api'
import type { UsageStats } from '@/lib/api'

export type { UsageStats, UsageDailyEntry as DailyData, UsageRecentEntry as RecentLog } from '@/lib/api'

export function useUsageStats(period: string) {
  return useQuery<UsageStats | null>({
    queryKey: ['usage', 'stats', period],
    queryFn: () => fetchUsageStats(period),
  })
}
